module.exports = {"id":"186723","name":"Yannick Boli","rating":"74","photo":"./data/images/photos/0/186723.png","club":{"name":"Colorado Rapids","logo":"./data/images/clubs/ColoradoRapids.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YannickBoli0.json
// module id = 4386
// module chunks = 0